import styled from 'styled-components';
import { Flex, Box } from 'reflexbox/styled-components';

import Section from '@/components/section';
import Title from '@/components/title';
import SubTitleBase from '@/components/sub-title';
import ParagraphBase from '@/components/paragraph';

const SubTitle = styled(SubTitleBase)`
  font-style: italic;
  font-weight: 400;
`;

const Paragraph = styled(ParagraphBase)`
  margin: 1.5em 0;
`;

const Mission = () => {
  return (
    <Section>
      <Flex flexWrap="wrap">
        <Box width={[1, 2/3]}>
          <Title maxSize="2.5em" minSize="1.25em">Our Mission</Title>
          <SubTitle>We’re creating a safer, more inclusive global financial system where anyone with an internet connection can contribute to global GDP.</SubTitle>
          <Paragraph>At Bidali we’re re-imagining commerce and believe that blockchain technology has the potential to change the way we do business.</Paragraph>
          <Paragraph>Using next generation payment rails we are building a platform that enables anyone in the world to send and receive money as easily as sending a photo and keep more of their money while preserving their privacy, while at the same time enabling businesses to grow their customer base and offer unique next-generation incentive programs all over the globe.</Paragraph>
        </Box>
      </Flex>
    </Section>
  );
};

export default Mission;
